import React, {useEffect, useCallback, useRef} from 'react'
import { useDispatch, useSelector} from 'react-redux'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import {
  ADD_PRODUCT_PAGE
} from '../utilities/function/common'

import {
  getCartToken
} from '../utilities/function/cartToken'

import {
  getOrderingFlowType
} from '../utilities/function/configuration'

import {
  isResponseCancelled
} from '../utilities/function/apiResponse'

import {
  getDataFromURL,
  getPageByURL
} from '../utilities/function/urlparams'

import { getSelectedProduct, updateConfig } from './action'
import Loading from '../components/shared/loading'



import Domain from '../components/pages/domain'



import { manageOrderingProductFlow } from '../utilities/function/manageServiceTypes'
import {CUSTOM_HOSTING_FLOW} from "../utilities/function/productFlow";

let ProductSelector = (props) => {
  const dispatch = useDispatch()
  const {
    getSelectedProductStatus,
    getSelectedProductData,
    getSelectedProductError,
    configurations,
    cartStatus
  } = useSelector(state => (state.app))
  const initFlag = useRef(false)
  const { location, history } = props
  const { pid, uuid, a, domain, query,promo,skipaddon } = getDataFromURL(location.search)
  const initProductCallback = useCallback(() => {
    if(!initFlag.current){
      if(pid){
        getSelectedProduct([pid], dispatch,getSelectedProductStatus,promo)
        initFlag.current = true
      }else{
        if(uuid){
          const productConfig = configurations[uuid]
          if(productConfig && productConfig.selectedProduct && getCartToken()){
            const {selectedProduct,discount} = productConfig
            const {id} = selectedProduct
            getSelectedProduct([id], dispatch,getSelectedProductStatus,discount)
            initFlag.current = true
          }else{
            history.push(history.location.pathname)
          }
        }
      }
    }
  }, [dispatch, pid,uuid,getSelectedProductStatus,initFlag,promo,configurations,history])

  useEffect(()=>{
    initProductCallback()
  },[initProductCallback,dispatch])

  const prevGetSelectedProductStatus = useRef(null)

  useEffect(()=>{
    if(a==='add' && pid){
      if(prevGetSelectedProductStatus.current!== getSelectedProductStatus){
        if(prevGetSelectedProductStatus.current==="loading"
          && getSelectedProductStatus==='success'){
          if(parseInt(pid) === getSelectedProductData.id) {
            let config = {
              selectedProduct: getSelectedProductData
            }
            //reset step when addon skipped
            if(skipaddon){
              config.step = 0
            }
            updateConfig(configurations, pid, config, dispatch)
          }
        }
        prevGetSelectedProductStatus.current = getSelectedProductStatus
      }
    }
  },[getSelectedProductStatus,skipaddon, getSelectedProductData, pid , a, dispatch,prevGetSelectedProductStatus,configurations])

  //url validation
  useEffect(()=>{
    const page = getPageByURL(location.search)
    if(!page){
      history.push(history.location.pathname)
    }else{
      //check if custom hosting product and doesn't have config then it will consider url is not valid
      if(page === ADD_PRODUCT_PAGE){
       const orderFlow = getOrderingFlowType(pid)
       if(orderFlow===CUSTOM_HOSTING_FLOW){
         if(configurations[pid] && !configurations[pid].config){
           history.push(history.location.pathname)
         }
       }
      }
    }




  },[location,history,configurations,pid])

  useEffect(() => {
    if(getSelectedProductStatus==='error'){
      if(!isResponseCancelled(getSelectedProductError)){
        history.push(history.location.pathname)
      }
    }
  }, [getSelectedProductStatus,history,getSelectedProductError])

  const renderLoading = () =>  {
    return (
      <div className='of-page'>
        <Loading className='of-page__loading' wrapper={true} />
      </div>
    )
  }
  const renderProductPage = () =>{
    if(getSelectedProductStatus==="loading" || cartStatus==="loading"){
      return (renderLoading())
    }
    if(getSelectedProductData && getSelectedProductData.attributes && getSelectedProductStatus==="success" && initFlag.current){
      const {id} = getSelectedProductData
      return (manageOrderingProductFlow(id))
    }
    return (<></>)
  }
  const renderDomainPage = () => {
    if(cartStatus==="loading"){
      return (renderLoading())
    }
    return (<Domain/>)
  }

  if(domain && query!==undefined){
    return (renderDomainPage())
  }

  if(a==='confdomain'){
    return (renderDomainPage())
  }

  return (renderProductPage())

}

ProductSelector.propTypes = {
  location: PropTypes.any,
  history: PropTypes.any
}

ProductSelector = withRouter(ProductSelector)

export default ProductSelector

